export interface BlogPost {
  slug: string
  title: string
  date: string
  category: string
  excerpt: string
}

export const blogPosts: BlogPost[] = [
  {
    slug: 'holiday-tree-lightings',
    title: 'Santa Barbara Holiday Tree Lightings: Where to See the Magic',
    date: 'November 24',
    category: 'Seasonal',
    excerpt:
      'Every lighting from Carpinteria to Goleta, with parking notes and which ones are worth a late bedtime.',
  },
  {
    slug: 'best-shady-parks',
    title: 'The Shadiest Parks in Town (For When It’s 88° at 11am)',
    date: 'August 6',
    category: 'Parks',
    excerpt:
      'Nine parks with real tree cover, plus which ones have bathrooms that are actually open.',
  },
  {
    slug: 'swim-lesson-guide',
    title: 'How to Pick a Swim Program Here — From a Parent Who Tried Four',
    date: 'May 19',
    category: 'Classes',
    excerpt:
      'What the waitlists really look like, what each program costs, and when registration opens.',
  },
]

export interface FeaturedBusiness {
  eyebrow: string
  name: string
  headline: string
  body: string
  cta: string
  image: string
  imageAlt: string
}

export const featuredBusiness: FeaturedBusiness = {
  eyebrow: 'Featured Santa Barbara business',
  name: 'Margaux Olverd',
  headline: 'Discovering local stories that make us smile',
  body:
    'Local author Margaux Olverd turned a moment of seeing a dog licking produce in the grocery store into a delightful tale. As a new mom herself, she brings real insight into what makes reading time meaningful — and how to encourage a genuine love of books.',
  cta: 'Read our full interview',
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/fa907dec-51d2-48de-a819-d4f56748b19d.jpg',
  imageAlt:
    'Local author sitting on a wooden bench above the coast in warm afternoon light',
}

export interface EditItem {
  name: string
  note: string
  price: string
}

export const familyEdit: EditItem[] = [
  { name: 'Canvas beach tote', note: 'Fits four towels and a boogie board', price: '$48' },
  { name: 'Pop-up shade tent', note: 'The one that goes up in 30 seconds', price: '$79' },
  { name: 'Mineral sunscreen stick', note: 'Reef safe, no tears', price: '$16' },
  { name: 'Sand-free blanket', note: 'Genuinely sand-free, we tested it', price: '$34' },
]

export const editImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/6c435888-e6e5-420d-a07e-f052b7a50306.jpg'

export const classesImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/207ac140-378b-458b-92d2-42a4af84a368.jpg'

export const parkImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/5af5e5ea-d2a8-45b1-9e8f-15cb9e84c1a8.jpg'

export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/d0dabc47-dcad-46d9-b68f-cd171f86e86a.jpg'
